import React, { Component } from "react";
import glamorous, { Div } from "glamorous";
import { css } from "glamor"
import UserCard from "../../common/UserCard";
import SearchSection from "../../blocks/SearchSection";
import LoadMore from "../../common/LoadMore"

const Grid = glamorous.div({
  display: "grid",
  gridTemplateColumns: "repeat(4,230px)",
  gridGap: "26px 34px",
  justifyContent: "center",
  paddingTop: 51,
  '@media (max-width: 1096px)': {
    gridTemplateColumns: "repeat(2,230px)",
  },
  '@media (max-width: 570px)': {
    gridTemplateColumns: "repeat(1,230px)",
  }
});

const Gradient =  glamorous.div({
  '@media (max-width: 570px)': {
    height: 258,
    background: "linear-gradient(to bottom, rgba(0,0,0,0) 0%, #181221 57.25%, #181221 100%)",
    position: "absolute",
    width: "100%",
    bottom: 0
  }
})

const LoadMoreContainer = glamorous.div({
  '@media (max-width: 570px)': {
    zIndex: 2,
    position: "absolute",
    width: "100%",
    bottom: 0
  }
})

const renderCards = (members,favToggle) => {
  if (members) {
    //var membersShuffled = members.sort(() => .5 - Math.random());
    return members.slice(0, 4).map(member => {
      return <UserCard 
        key={member.account_id} 
        member={member}
        favToggle={favToggle} 
      />;
    });
  }
};
class ExploreMembers extends Component {
  render() {
    const { members, favToggle, dropInSearchResults } = this.props;
    return (
      <SearchSection
        title="Explore Members"
        backgroundColor="#1E1626"
        gradient="radial-gradient(circle, #1E1626 0%, rgba(30,22,38,0) 100%), radial-gradient(circle, #1E1626 0%, rgba(30,22,38,0) 100%), linear-gradient(180deg, rgba(0,0,0,0) 0%, #000000 100%)"
      >
        <Grid>{renderCards(members,favToggle)}</Grid>
        <LoadMoreContainer>
          <LoadMore dropInSearchResults={dropInSearchResults}
          searchUsers={true}
          filters={{distance: 100}}
          />
        </LoadMoreContainer>
        <Gradient />

      </SearchSection>
    );
  }
}

export default ExploreMembers;



// WEBPACK FOOTER //
// ./src/components/pages/Search/ExploreMembers.jsx